import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Buefy from "buefy";
import "buefy/dist/buefy.min.css";
import "@mdi/font/css/materialdesignicons.min.css";
import VueCompositionApi from "@vue/composition-api";

Vue.config.productionTip = false;

Vue.use(Buefy);
Vue.use(VueCompositionApi);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
